import {
  ExtendableImage,
  ExtendableImageProps,
} from '@design-system/extendable-image';
import {
  RetailerLink,
  RetailersBlockProps,
} from '@design-system/retailers-block';
import {
  getLocalStorageData,
  setLocalStorageData,
} from '@phx-husky/local-storage';
import React from 'react';

import { RetailersPageBlockProps } from '~/components/RetailersPageBlock/models';
import TMPLinkWrap from '~/components/TMPLinkWrap';
import { imageMapper } from '~/mappers/image';
import { linkMapper } from '~/mappers/link';
import { pageBlockMapper } from '~/mappers/pageBlock';
import { gtmService } from '~/services/gtm';
import { SalsifyProductData } from '~/types/common';
import { GTM_LOCALSTORAGE_DATA } from '~/utils/constants';

import { Retailers, RetailersBase, RetailersPageBlock } from './models';

const retailersBaseMapper = ({ type, items }: RetailersBase) => ({
  type,
  retailerLinks: items.map((item) => {
    const image = imageMapper(item.image) as ExtendableImageProps;
    const linkItem = { ...item.link, variant: 'retailer', size: 'large' };

    return {
      link: { component: TMPLinkWrap, props: linkMapper(linkItem) },
      titleAsText: item.titleAsText,
      children: <ExtendableImage {...image} />,
    } as RetailerLink;
  }),
});

export const retailersMapper = (
  retailers: Retailers,
  productData: SalsifyProductData
): RetailersBlockProps => {
  const onClickRetailerName = (title: string, url: string) => {
    setLocalStorageData(GTM_LOCALSTORAGE_DATA.lastRetailerTitle, title);
    const lastProductIndex = getLocalStorageData(
      GTM_LOCALSTORAGE_DATA.lastProductIndex
    );
    gtmService.emitRetailerClick(title, url);
    gtmService.emitSelectPromotion(productData, title, lastProductIndex);
  };

  return {
    ...retailersBaseMapper(retailers),
    label: retailers.label,
    titleOptions: retailers.labelSettings,
    onClickRetailerName,
  };
};

export const retailersBlockMapper = (
  retailers: RetailersPageBlock
): RetailersPageBlockProps => ({
  pageBlock: pageBlockMapper(retailers.pageBlock),
  componentId: retailers.componentId,
  retailers: retailersBaseMapper(retailers),
  uid: retailers.uid,
});
